export const getLocale = (countryCode, locales) => {
    return locales.find(locale => locale.code === countryCode);
};
//# sourceMappingURL=index.js.map